import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import styles from './Box.less';

const cx = classnames.bind(styles);

export default React.memo(Box);

Box.propTypes = {
  as: PropTypes.any,
  className: PropTypes.string,
  direction: PropTypes.oneOf(['row', 'column']),
  justify: PropTypes.oneOf([
    'center',
    'end',
    'flex-end',
    'flex-start',
    'inherit',
    'left',
    'normal',
    'right',
    'space-around',
    'space-between',
    'space-evenly',
    'start',
    'stretch',
  ]),
  align: PropTypes.oneOf([
    'center',
    'end',
    'flex-end',
    'flex-start',
    'inherit',
    'normal',
    'self-end',
    'self-start',
    'start',
    'stretch',
  ]),
};
function Box({ as: Tag = 'div', className, direction, align, justify, style, ...props }) {
  const inline = {
    ...style,
    alignItems: align,
    justifyContent: justify,
  };

  return <Tag className={cx('root', className, direction)} {...props} style={inline} />;
}
